import { IExportContactsParams } from '@app/models/interfaces';
import Api from '@app/services/api';
import { useExportDownload } from '@app/services/hooks/useExportDownload';

export const useExportContactsQuery = () => {
  return useExportDownload<IExportContactsParams>({
    downloadPrefix: 'contacts',
    getFilePath: (filename) => `/dictionaries/contacts/exported/${filename}`,
    mutationFn: (params) => Api.dictionaries.exportContacts(params),
  });
};
